export { default } from "./FactOpinionSorter";
